module.exports = __webpack_public_path__ + "img/Haiti.d7378d26.svg";